module.exports = __webpack_public_path__ + "static/assets/44fd91d9e3ac6b6f10840bff8441e08e.png";